module.exports = "/assets/data/045f9db6c888f47cf841fafcc227a2e8-BR7.data.json";